@if (isDebugging) {
  <div class="debug-switches" [formGroup]="settingsForm">
    <label>
      <input type="checkbox" formControlName="isPropak">
      Propak
    </label>
    <label>
      <input type="checkbox" formControlName="isTestEnvironment">
      Test
    </label>
    <button (click)="toggleOverlay()">
      {{ showLoadingOverlay ? 'Hide': 'Show' }} Loading
    </button>
  </div>
}

<!-- layout-wrapper layout-menu-static layout-menu-light -->
<div class="layout"  [ngClass]="{ 'menu-open': menuActive }">
  <header theme-header
    [isPropak]="isPropak"
    [isTestEnvironment]="isTestEnvironment"
    (menuButtonClick)="toggleMenu()"
    [ngClass]="{ 'test': isTestEnvironment }"></header>

  <nav theme-menu [reset]="resetMenu"></nav>

  <main>
    <div class="loading-overlay" [class.shown]="showLoadingOverlay">
      @if (!authMessage) {
        @if (showJarvisForklift) {
          <img
            src="/jarvis-forklift.gif"
            alt="Jarvis Forklift Loading Animation"
            aria-label="Loading"
          />
        }
        @else {
          <pallet-loading-indicator
            [showLabel]="true"
            size="lg"
            color="full"
          ></pallet-loading-indicator>
        }
      }
    </div>

    <nav theme-breadcrumb class="breadcrumb"></nav>

    <ng-content></ng-content>

    <div class="layout-content">
        <router-outlet></router-outlet>
    </div>

    <footer theme-footer [buildNumber]="buildNumber"></footer>
  </main>

  <app-toast position="top-right"></app-toast>
</div>
